import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import {Link, BrowserRouter, Route} from 'react-router-dom'
import ProjectAll from './ProjectAll';

const data = [
    {
        Name: 'Typing Speed Test',
        url: 'https://www.keybr.com/cover.png',
        des: 'You can test your typing speed here. this app is made with ReactJS'
    },

    {
        Name: 'News Api',
        url: 'https://cdn.dribbble.com/users/1998175/screenshots/15193792/media/298264c1ce856398c313dde0398ba00c.jpg?compress=1&resize=400x300',
        des: 'I use reactJS and a public Api to build it.'
    }]

           

const Projects = () => {
    const [dataHook, setdataHook] = useState(data) 
    return (
        <div id='p-all' style={{textAlign: 'center'}}>
            <div className='fau'></div>
            <div className='banner'>
                <h1>Projects</h1>
            </div>
           
            
            <div className='ps-contain'>
                <h1 style={{padding: '20px'}}>Recent Works</h1>
                <div className='gs-container'>
                    {dataHook.map((v, i) => {
                        let url = 'https://images.unsplash.com/photo-1572177812156-58036aae439c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cHJvamVjdHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80';
                        if(v.url){
                            url = v.url;
                            console.log(v.url)
                        } 
                        return (
                            <div style={{background: '#afbac9', borderRadius: '2px', padding: '50px', width: '90%', margin: '50px'}}>
                                <div>
                                    <img src={url} alt='siam' height='100px'></img>
                                </div>
                                <div style={{width: '50%', margin: 'auto'}}>
                                    <h3>{v.Name}</h3>
                                    <p style={{color: 'gray'}}>{v.des}</p>
                                </div>
                                
                            </div>
                        )
                        
                    })}

                
                    
                </div>
                <div style={{marginTop: '50px'}}>
                <a href={window.location.href+`project`} style={{
                    margin: 'auto',
                    width: '30%',
                    textDecoration: 'none'
                }} className='a-btn'><span style={{color: 'white'}}>See More Projects</span></a>
       
                </div>
              
            </div>
            
        </div>
    );
};

export default Projects;